import { Card } from '../../components/Card/Card';
import { Button } from '../../components/Button/Button';
import { AccountMonthTable } from './AccountMonthTable';
import { AktuelSaldo } from './AktuelSaldo';
import { useUiStore } from '../../store/ui';
import {
  useCreateAccount,
  useDeleteAccount,
  useUpdateAccount,
  useYearBundle,
} from '../../store/queryHooks';
import styles from './KontiPage.module.css';

export function KontiPage() {
  const { year, month, setToast } = useUiStore();
  const bundle = useYearBundle(year);
  const createAccount = useCreateAccount(year);
  const updateAccount = useUpdateAccount(year);
  const deleteAccount = useDeleteAccount(year);

  if (bundle.isPending) return <div>Indlæser…</div>;
  if (bundle.isError || !bundle.data) return <div>Kunne ikke hente året.</div>;

  const accounts = bundle.data.accounts;

  async function onAdd() {
    try {
      await createAccount.mutateAsync({ name: 'Ny konto', sub: 'Manuel', badge: 'K' });
      setToast('Konto tilføjet');
    } catch {
      setToast('Kunne ikke tilføje konto');
    }
  }

  async function onDelete(id: number) {
    if (!window.confirm('Slet denne konto?')) return;
    try {
      await deleteAccount.mutateAsync(id);
      setToast('Konto slettet');
    } catch {
      setToast('Kunne ikke slette konto');
    }
  }

  async function onRename(id: number, name: string) {
    const a = accounts.find((x) => x.id === id);
    if (!a || a.name === name) return;
    try {
      await updateAccount.mutateAsync({ id, name });
    } catch {
      setToast('Kunne ikke gemme navn');
    }
  }

  async function onEditAmount(id: number, m: number, next: number | null) {
    const a = accounts.find((x) => x.id === id);
    if (!a) return;
    const amounts = a.amounts.slice();
    amounts[m] = next;
    try {
      await updateAccount.mutateAsync({ id, amounts: amounts as (number | null)[] });
    } catch {
      setToast('Kunne ikke gemme saldo');
    }
  }

  return (
    <div className={styles.wrap}>
      <Card>
        <div className={styles.head}>
          <span /> {/* spacer to keep button aligned right in the header of the table */}
          <Button onClick={onAdd}>+ Tilføj konto</Button>
        </div>
        <AccountMonthTable
          year={year}
          monthIdx={month}
          accounts={accounts}
          onRename={onRename}
          onDelete={onDelete}
          onEditAmount={onEditAmount}
        />
      </Card>

      <AktuelSaldo />
    </div>
  );
}
